var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-tooltip',{attrs:{"title":_vm.$t('base.import')}},[_c('label',{staticClass:"page-block__import"},[_c('input',{ref:"importFile",staticClass:"page-block__import-input",attrs:{"type":"file","accept":".json,.zip"},on:{"change":_vm.importFile}}),_c('a-icon',{staticClass:"page-block__import-icon",attrs:{"type":"import"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }